<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="EBook-Break" id="_idParaDest-7"> </p>
<p class="CT ParaOverride-10">Characters</p>
<p class="_W-Opener ParaOverride-5">Prologue</p>
<p class="_W ParaOverride-11"><span class="CharOverride-6">1844</span></p>
<p class="BT1stPara ParaOverride-1">Elise Durel . . . age fourteen, a suburban girl</p>
<p class="BT1stPara ParaOverride-1">Emile Sabatier . . . age seventeen, a boy of prospects</p>
<p class="_W ParaOverride-12">Parts 1–5</p>
<p class="_W ParaOverride-11"><span class="CharOverride-6">1862–1863</span></p>
<p class="BT1stPara ParaOverride-1"><span class="CharOverride-2">New Orleans</span></p>
<p class="BT1stPara ParaOverride-1">Joseph Woolsack . . . a slaver’s son</p>
<p class="BT1stPara ParaOverride-1">Angel Woolsack . . . his father</p>
<p class="BT1stPara ParaOverride-1">Elise Woolsack . . . wife of Angel, mother of Joseph</p>
<p class="BT1stPara ParaOverride-1">Inés Pichon . . . her friend and neighbor, a free woman of color</p>
<p class="BT1stPara ParaOverride-1">Ligeia . . . handmaid, human property of Elise Woolsack</p>
<p class="BT1stPara ParaOverride-1">Dr. Emile Sabatier . . . scientist, physician, agent to Angel Woolsack</p>
<p class="BT1stPara ParaOverride-1">Lydia Sabatier . . . his wife, a spiritualist</p>
<p class="BT1stPara ParaOverride-13"><span class="CharOverride-2">New England</span></p>
<p class="BT1stPara ParaOverride-1">General Benjamin F. Butler . . . Massachusetts jurist, politician, ­commander Union Forces, Department of the Gulf</p>
<p class="BT1stPara ParaOverride-1">Sarah Butler . . . his wife</p>
<p class="BT1stPara ParaOverride-1">Major George Strong . . . a Vermonter, Butler’s adjutant</p>
<p class="BT1stPara ParaOverride-13"><span class="CharOverride-2">The Golden Circle</span></p>
<p class="BT1stPara ParaOverride-1">Marina Fandal . . . an orphan, late of Cuba</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eBook43516.vue?254da8ac